import React, { Component } from 'react';
import store from 'store2';
import config from '../../config';
import Loading from '../components/Loading';

export default class Logout extends Component {
  componentDidMount() {
    store.clearAll();
    window.location.href = [
      config.auth.domain,
      `/user/logout?post_logout_redirect_uri=`,
      config.auth.postLogoutRedirectUri,
    ].join('');
  }

  render() {
    return <Loading />;
  }
}



// WEBPACK FOOTER //
// ./src/common/auth/Logout.js